export default {
  alerts: [],
  selectedAlert: null,
  language: "he",
  statisticsInterval: null,
  totalMessages: 0,
  totalAlerts: 0,
  lastUpdate: null,
  // Advanced statistics
  averageMessageRate: 0,
  // WebSocket state
  websocket: null,
  websocketConnected: false,
  lastKeepAlive: null,
  layerVersion: null,
  connectionStatus: null,
  historyData: null,
  historyRequestId: null,
  // New state for API requirements
  shapefileContent: null,
  shapefileVersion: null,
  shapefileVersionResponse: null,
  historyRequest: null,
  historyResponse: null,
  uiTtlMinutes: 0,
  // Auth state
  authToken: localStorage.getItem("authToken") || null,
  authUser: localStorage.getItem("authUser") || null,
  isAuthenticated: !!localStorage.getItem("authToken"),
};
